<div class="container space">
  <div class="row">
    <div class="col-12 text-center">
      <a href="#" routerLink="/">
        <img src="/assets/Logo.png" class="logo">
      </a>
    </div>
  </div>
</div>
